function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "grad1",
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5CA2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "48%",
  stopColor: "#1248DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#DF0FB3"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4.33333C0 2.5742 0 1.69463 0.370184 1.17415C0.693276 0.719884 1.1913 0.421071 1.74417 0.349764C2.37762 0.268063 3.15371 0.681977 4.70588 1.5098L24.7059 12.1765C26.4248 13.0932 27.2843 13.5516 27.566 14.162C27.8113 14.6937 27.8113 15.3063 27.566 15.838C27.2843 16.4484 26.4248 16.9068 24.7059 17.8235L4.70588 28.4902C3.15371 29.318 2.37762 29.7319 1.74417 29.6502C1.1913 29.5789 0.693276 29.2801 0.370184 28.8258C0 28.3054 0 27.4258 0 25.6667V4.33333Z",
  fill: "url(#grad1)"
});

var SvgPlay = function SvgPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play.e1d54c98.svg";
export { ForwardRef as ReactComponent };